import React from "react"
import { useUID } from "react-uid"
import getValue from "get-value"
import { getImageData } from '@utils/image'
import ImageBlock from "@components/image-block"

const ImagesBlock = ({ id, images }) => {
  const totalImages = images.length
  const columnClasses = {
    1: `sm:col-span-12 mx-auto`,
    2: `sm:col-span-6`,
    3: `sm:col-span-4`,
  }
  const columnClass = getValue(columnClasses, totalImages, { default: 1 })
  const classList = `w-full ${columnClass}`

  return (
    <div id={id} className="grid gap-5 md:gap-10 content-builder sm:grid-cols-12">
      {images.map(imageBlock => {
        const uid = useUID()
        const imageAssetId = getValue(imageBlock, 'image.asset._ref') || getValue(imageBlock, 'image.asset.id')
        const imageMap = {
          1: getImageData(imageAssetId, { width: 1400, aspectRatio: 16 / 9, fit: 'crop' }),
          2: getImageData(imageAssetId, { width: 500, height: 420, fit: 'crop' }),
          3: getImageData(imageAssetId, { width: 500, height: 500, fit: 'crop' }),
        }
        const image = getValue(imageMap, totalImages, { default: 1 })
        const imageAlt = getValue(imageBlock , 'title') || imageBlock.image?.asset?.altText || imageBlock?.image?.asset?.filename

        return (
          <div className={classList} key={`image-${uid}`}>
            <ImageBlock
              image={image}
              alt={imageAlt}
            />
          </div>
        )
      })}
    </div>
  )
}

export default ImagesBlock
